import clsx from "clsx";
import footerLogo from "../../../../../assets/landing/agnt-logo-footer.png";

type AgntLogoProps = {
  isHeader?: boolean;
};

const AgntLogo: React.FC<AgntLogoProps> = ({ isHeader = false }) => {
  return (
    <div
      className={clsx(
        "flex items-center gap-[0.857vw] max-lg:gap-[2.4vw] max-lg:pl-[1.8vw] max-lg:pt-[1.8vw] pl-[0.642vw]",
        isHeader &&
          "!gap-[0.571vw] max-lg:!gap-[2.13vw] pl-[0.428vw] max-lg:pl-[1.6vw] pt-[0.428vw] max-lg:pt-[1.6vw]"
      )}
    >
      <img
        src={footerLogo}
        className={clsx(
          "size-[3.428vw] max-lg:size-[9.6vw]",
          isHeader && "max-lg:!size-[8.53vw] !size-[2.29vw]"
        )}
        alt={"AGNT.Hub logo"}
      />
      <h3
        className={clsx(
          "text-[2.571vw] leading-[1.1] max-lg:text-[7.2vw] font-luxora-medium text-black",
          isHeader && "!text-[1.7vw] max-lg:!text-[6.4vw]"
        )}
      >
        AGNT.Hub
      </h3>
    </div>
  );
};

export default AgntLogo;
